import { render, staticRenderFns } from "./OngoingApplications.vue?vue&type=template&id=009438ec&scoped=true&"
import script from "./OngoingApplications.vue?vue&type=script&lang=js&"
export * from "./OngoingApplications.vue?vue&type=script&lang=js&"
import style0 from "./OngoingApplications.vue?vue&type=style&index=0&id=009438ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009438ec",
  null
  
)

export default component.exports